<div class="container">
  <p class="warning" *ngIf="isUserUpdating()">Your account is currently being updated, please come back later.</p>
  <p class="warning" *ngIf="errorMessage">{{ errorMessage }}</p>
  <p
    *ngIf="!user.course_code"
    class="warning"
    role="status"
    id="no_course_warning"
    aria-label="No Assignment system available">
    You have arrived at Noteable without any <em>Course</em> details: the Assignments system will not be available to
    you.
  </p>

  <!-- Notebook Selection + Help/Guides Panel -->
  <section class="container-selector-panels" aria-label="Start/stop notebook servers">
    <section *ngIf="showStartButtons()" aria-label="notebook start selector" id="notebook-selection">
      <section class="support-box notebook-select" aria-label="notebook server selection" id="notebook-selector-form">
        <h2>Please select a personal notebook server</h2>
        <form [formGroup]="form" aria-label="Notebook Server selector">
          <select
            name="containerSelect"
            id="containerSelect"
            aria-label="Select notebook"
            formControlName="select"
            [attr.disabled]="isServerLive() || isUserUpdating() ? true : null">
            <!-- prettier-ignore -->
            <option
                *ngFor="let container of containers | collabContainerPipe: false"
                [value]="container.id">
                {{ container.display_name }}
              </option>
          </select>
          <div>
            <button
              class="launch-page-button"
              id="start-button"
              (click)="startServer()"
              [attr.disabled]="submit.getSubmitting() || isServerLive() || isUserUpdating() ? true : null"
              [innerHTML]="submit.getSubmitText()"></button>
          </div>
        </form>
      </section>

      <!-- Help and Guides -->
      <section aria-labelledby="h3_guides_diag" class="support-box" id="help_guides">
        <h3 id="h3_guides_diag">
          <a href="/help_guides" aria-label="A collection of Help and Guides resources">Help and Guides</a>
        </h3>
        <ul>
          <li>Helpful resources for students, lecturers, school teachers and users new to notebooks</li>
          <li>Guides for assignments, collaboration, multiple markers in a course and more</li>
        </ul>
      </section>
    </section>

    <section *ngIf="!showStartButtons()" aria-label="Running notebook options" id="running_notebook_options">
      <h2 id="running_notebook_buttons">
        You have a running Notebook Server. Would you like to reconnect to it, or shut it down?
      </h2>
      <button
        class="launch-page-button"
        (click)="reconnect()"
        [attr.disabled]="!isServerLive() || isUserUpdating() || isConnecting() ? true : null">
        Reconnect
      </button>
      <button
        class="launch-page-button"
        id="stop-button"
        title="Stop"
        (click)="stopServer()"
        [attr.disabled]="shutdown.getSubmitting() || !isServerLive() ? true : null"
        [innerHTML]="shutdown.getSubmitText()"></button>
    </section>
    <h4 *ngIf="progressText" role="status" [attr.aria-label]="progressText" id="progress info">{{ progressText }}</h4>
  </section>

  <!-- Notebook Description - always shown for the currently selected notebook -->
  <section
    *ngIf="selectedNotebook"
    id="description_content_section"
    class="support-box notebook-description-boxes brief-description-box notebook-description-main-content"
    [attr.aria-label]="'Brief description for ' + selectedNotebook.display_name + ' and link to full descriptions'"
    aria-live="polite"
    aria-atomic="true">
    <section
      class="notebook-description-summary"
      [attr.aria-label]="selectedNotebook.display_name + ' brief description'">
      <h3 id="notebook_desc_title">{{ selectedNotebook.display_name }}</h3>
      <h4 *ngIf="selectedNotebook.restricted" id="h4_{{ selectedNotebook.description.service }}_restricted">
        (Access granted to a restricted notebook)
      </h4>
      <p>{{ selectedNotebook.description.description }}</p>
      <ul>
        <ng-container *ngFor="let section of selectedNotebook.description.sections">
          <li *ngIf="!section.libraries || section.libraries.length === 0">
            <span [innerHTML]="section | getListItemText"></span>
          </li>
        </ng-container>
      </ul>
      <button
        class="launch-page-button"
        [attr.aria-label]="'Read more details about ' + selectedNotebook.display_name"
        (click)="openDetails()">
        Read more
      </button>
    </section>

    <aside class="notebook-description-aside" aria-label="Full list of all notebook descriptions">
      <p>
        To compare the similarities and differences, the
        <a class="notebook-descriptions-link" href="/notebook-descriptions">Notebook Descriptions</a>
        page contains the full list for all available notebook servers.
      </p>
    </aside>
  </section>

  <!-- Modal Dialog -->
  <dialog
    *ngIf="selectedNotebook"
    class="support-box notebook-description-boxes modal-dialog"
    id="description_modal"
    aria-labelledby="modal_desc_title"
    closedby="none"
    close="">
    <div class="modal-body">
      <h3 id="modal_desc_title">{{ selectedNotebook.display_name }}</h3>
      <h4 *ngIf="selectedNotebook.restricted" id="h4_{{ selectedNotebook.description.service }}_restricted">
        (Access granted to a restricted notebook)
      </h4>
      <p>{{ selectedNotebook.description.description }}</p>
      <ul>
        <li *ngFor="let section of selectedNotebook.description.sections">
          <span [innerHTML]="section | getListItemText"></span>
        </li>
      </ul>
      <button
        id="close-description-button"
        data-testid="modal-close-button"
        class="launch-page-button"
        (click)="closeDetails()">
        Close
      </button>
    </div>
  </dialog>
</div>
